module.exports = __webpack_public_path__ + "img/pdf.8569fed4.png";